import React from "react";
import { Route, Switch } from "react-router-dom";

import { NotFoundPage } from "@app/components/pages/not-found-page";

import { HomePage } from "@app/components/pages/home-page";
import { LoginPage } from "@app/components/pages/login-page";
import { StatementsPage } from "@app/components/pages/statements-page";
import { AlbumsView } from "@app/components/pages/albums/view";
import { AlbumsCreate } from "@app/components/pages/albums/create";
import { AlbumsEdit } from "@app/components/pages/albums/edit";
import { TracksView } from "@app/components/pages/tracks/view";
import { ArtistsView } from "@app/components/pages/artists/view";
import { UsersIndex } from "@app/components/pages/users/index";
import { UsersCreate } from "@app/components/pages/users/create";
import { UsersEdit } from "@app/components/pages/users/edit";
import { DeliveriesIndex } from "@app/components/pages/deliveries/index";
import { BundlesIndex } from "@app/components/pages/bundles/index";
import { BundlesCreate } from "@app/components/pages/bundles/create";
import { BundlesView } from "@app/components/pages/bundles/view";
import { PlaylistsIndex } from "@app/components/pages/playlists/index";
import { PlaylistsView } from "@app/components/pages/playlists/view";
import { StatisticsIndex } from "@app/components/pages/statistics/index";
import { ReportsIndex } from "@app/components/pages/reports/index";
import { ReportsCreate } from "@app/components/pages/reports/create";
import { SearchPage } from "@app/components/pages/search";
import { TrendsPage } from "@app/components/pages/trends";
import { RequiresAuth } from "@auth/components/RequiresAuth";
// import { Dashboard } from "./components/dashboard";
// import { RequireAuth } from "./components/auth/require-auth";

import { canViewUser, canCreateUser, canUpdateUser } from "@auth/selectors";
import { canViewDelivery } from "@deliveries/selectors";
import { canGenerateReport, canViewReport } from "@reports/selectors";
import { canViewAlbum, canCreateAlbum, canUpdateAlbum, canViewTrack, canViewArtist } from "@music/selectors";
import { canViewGlobalStats, canViewSales } from "@sales/selectors";
import { canViewBundle, canCreateBundle } from "@upload/selectors";
import { canViewPlaylist } from "@vendor/selectors";

const loginRoute = "/login";

const Routes = () => (
    <Switch>
        <Route exact path="/login" component={LoginPage} />
        <Route exact path="/search" component={RequiresAuth(SearchPage, loginRoute)} />
        <Route exact path="/statements" component={RequiresAuth(StatementsPage, loginRoute, canViewReport)} />
        <Route exact path="/albums/create" component={RequiresAuth(AlbumsCreate, loginRoute, canCreateAlbum)} />
        <Route exact path="/albums/view/:id" component={RequiresAuth(AlbumsView, loginRoute, canViewAlbum)} />
        <Route exact path="/albums/edit/:id" component={RequiresAuth(AlbumsEdit, loginRoute, canUpdateAlbum)} />
        <Route exact path="/tracks/view/:id" component={RequiresAuth(TracksView, loginRoute, canViewTrack)} />
        <Route exact path="/artists/view/:id" component={RequiresAuth(ArtistsView, loginRoute, canViewArtist)} />
        <Route exact path="/users" component={RequiresAuth(UsersIndex, loginRoute, canViewUser)} />
        <Route exact path="/users/create" component={RequiresAuth(UsersCreate, loginRoute, canCreateUser)} />
        <Route exact path="/users/edit/:id" component={RequiresAuth(UsersEdit, loginRoute, canUpdateUser)} />
        <Route exact path="/deliveries" component={RequiresAuth(DeliveriesIndex, loginRoute, canViewDelivery)} />
        <Route exact path="/bundles" component={RequiresAuth(BundlesIndex, loginRoute, canViewBundle)} />
        <Route exact path="/bundles/create" component={RequiresAuth(BundlesCreate, loginRoute, canCreateBundle)} />
        <Route exact path="/bundles/view/:id" component={RequiresAuth(BundlesView, loginRoute, canViewBundle)} />
        <Route exact path="/statistics" component={RequiresAuth(StatisticsIndex, loginRoute, canViewGlobalStats)} />
        <Route exact path="/playlists" component={RequiresAuth(PlaylistsIndex, loginRoute, canViewPlaylist)} />
        <Route exact path="/playlists/view/:id" component={RequiresAuth(PlaylistsView, loginRoute, canViewPlaylist)} />
        <Route exact path="/reports" component={RequiresAuth(ReportsIndex, loginRoute, canGenerateReport)} />
        <Route exact path="/reports/create" component={RequiresAuth(ReportsCreate, loginRoute, canGenerateReport)} />
        <Route exact path="/trends" component={RequiresAuth(TrendsPage, loginRoute, canViewSales)} />
        <Route exact path="/" component={RequiresAuth(HomePage, loginRoute)} />
        <Route path="*" component={NotFoundPage} />
    </Switch>
);

export { Routes };
